import { Button } from '@/components/ui/button'
import type React from 'react'

type HeartbeatButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & { label?: string; size?: 'default' | 'sm' | 'lg' | 'icon'; variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link' }

export const ButtonHeartbeatEffect: React.FC<HeartbeatButtonProps> = ({ label, className = '', children, size = 'sm', variant = 'destructive', ...rest }) => {
  return (
    <Button
      variant={variant as any}
      size={size as any}
      className={`animate-heartbeat dark:bg-destructive/100 ${className}`}
      {...rest}
    >
      {children ?? label ?? 'Onboard Client'}
    </Button>
  )
}

const ButtonHeartbeatEffectDemo = () => {
  return (
    <ButtonHeartbeatEffect />
  )
}

export default ButtonHeartbeatEffectDemo
